export default __webpack_public_path__ + "efa6cf796b72acb4622901a56ac4bec3.webp";